import { isPlainObject } from "@reduxjs/toolkit"
import { UUID } from "shared-ts/classes/uuid"

export function stringify(s: unknown): string {
  return JSON.stringify(s, (_, value) => {
    switch (true) {
      case isPlainObject(value): {
        const obj = value as Record<string, unknown>
        return Object.keys(obj)
          .sort()
          .reduce((acc: Record<string, unknown>, key) => {
            acc[key] = obj[key]
            return acc
          }, {})
      }
      case typeof value === "bigint":
        return value.toString()
      default:
        return value
    }
  })
}

// fixParsedId extracts a valid PBUUID after parsing a UUID
// with JSON.parse that was stringified using the above
// custom stringify function
export function fixParsedId(idObj?: { bytes: object }) {
  if (!idObj?.bytes) {
    return undefined
  }

  const bytes = new Uint8Array(Object.values(idObj.bytes))
  return UUID.fromBytes(bytes)
}
